export default {
  header: 'We moeten je telefoonnummer verifiëren',
  buttons: {
    confirm: 'Bevestigen',
  },
  toasts: {
    invalid_code: 'Ongeldige code. Probeer het opnieuw.',
  },
};
